module.exports = __webpack_public_path__ + "static/media/navbar_lo11go.c883f50c.jpg";